import { render, staticRenderFns } from "./landSearch.vue?vue&type=template&id=164e2622&"
import script from "./landSearch.vue?vue&type=script&lang=js&"
export * from "./landSearch.vue?vue&type=script&lang=js&"
import style0 from "./landSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports